/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class AddCourseModal {
  async GetCourses(agu : string, orgYearGU : string, searchStr : string, gradeCode : string, subjectArea : string, gradReqDefGu : string, gradReqSubAreas : Array<string>) : Promise<Array<pxp.FourYearPlannerCourseVM>> {
    return await componentApi.call('pxp', 'add-course-modal', 'AddCourseModal', 'GetCourses', {
      agu,
      orgYearGU,
      searchStr,
      gradeCode,
      subjectArea,
      gradReqDefGu,
      gradReqSubAreas,
    });
  }
}

export class AddCourseModalTransformer {
  async Transform(htmlStream : any) : Promise<any> {
    return await componentApi.call('pxp', 'add-course-modal', 'AddCourseModalTransformer', 'Transform', {
      htmlStream,
    });
  }
}
export default new AddCourseModal()
